import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../../app.service';

@Injectable()
export class RfaGuard implements CanActivate {
  constructor(private router: Router, private actr: ActivatedRoute, public appState: AppState) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):  boolean {
      const role = this.appState.get('role');
      if (role === 'Admin User' || role === 'RFA User' ||role === 'RS Supervisor') {
        return true;
      } else {
        this.router.navigate(['/profile']);
        return false;
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/rfa.guard.ts